import React, { Component } from "react";
import { Text, View, TouchableOpacity } from "react-native";
import ButtonGradient from "../../components/button-gradient";
import { button, Colors, Flex, FontFamily } from "../../styles/appStyles";
import apiHelpers from "../../utils/api-helpers";
import { helpers } from "../../utils/helpers";
import getImagePath from "../../utils/image-helper";
import AuthenticationWrapper from "../authentication-wrapper";
import CustomImage from "../custom-image";
import PostContent from "../post-content";
import { renderBorderColor } from "../../screens/yesterday/renderBorderColor";
import truncate from "truncate-html";
import moment from "moment";

const YesterdayLogo1 = getImagePath("img/YesterdayLogo1.png");
const yesterdayBadge = getImagePath("img/yesterdayBadge.png");

const bg2 = getImagePath("img/bg2.png");
const yesterdayLogo = getImagePath("icons/yesterdayLogo.png");
const healthcare = getImagePath("icons/healthcare.png");
const rightArrow = getImagePath("icons/rightArrow.png");
export class HomeYesterdayStory extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    // const {isAuthenticated, fetchToken} = this.props.auth
    // let token = webView ? (process.browser ? (isAuthenticated?fetchToken:false) : this.props.token) : this.props.user?.userData?.data?.token;
    this.state = {
      isUserLoggedIn: this.props.token,
      storyData: [],
    };
  }

  componentDidMount = () => {
    this.getEditions();
  };

  getEditions = () => {
    const { token, isUserLoggedIn } = this.state;
    let endpoint = `/yesterday/editions`;
    let body = {};
    body = {
      sort_on: "published_date",
      sort_by: "DESC",
      // published_date: moment(new Date()).format("DD-MM-YYYY"),
      start_date: moment(new Date()).subtract(30, "days").format("DD-MM-YYYY"),
      end_date: moment(new Date()).format("DD-MM-YYYY"),
      limit: 1,
      truncate: 1,
      count: 120,
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, token)
      .then((res) => {
        this.setState({
          storyData: res.data.editions[0],
        });
      })
      .catch((error) => {
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  render() {
    let { darkMode, token } = this.props;
    let { storyData } = this.state;

    return (
      <View
        style={{
          marginTop: !helpers.isDesktop() ? "-70px" : 0,
          width: "100%",
          backgroundColor: darkMode ? "#121212" : "#F3F5FF",
        }}
      >
        <View
          style={
            ([
              { padding: helpers.isDesktop() ? 10 : 20 },
              darkMode && { backgroundColor: Colors.darkPurple },
            ],
              !helpers.isDesktop() && {
                paddingTop: 40,
                paddingLeft: 20,
                paddingBottom: 20,
                paddingRight: 20,
              })
          }
        >
          <View
            style={[
              helpers.isDesktop() && {
                padding: helpers.isDesktop() ? 20 : 10,
                maxWidth: "100%",
                width: "100%",
                margin: "auto",
              },
            ]}
          >
            <View
              style={{
                width: 151.23,
                position: 'relative'
              }}
            >
              {/* <CustomImage
                resizeMode={"contain"}
                source={YesterdayLogo1}
                require={true}
                style={[
                  helpers.isDesktop()
                    ? { width: "100%", height: "auto" }
                    : { width: "100%", height: 20 },
                ]}
                webStyle={{ backgroundColor: darkMode ? "white" : "" }}
                altText={"Yesterday Logo"}
              /> */}


              <View
                style={{
                  clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 83%, 0 100%)',
                  background: 'linear-gradient(17.24deg, #55C79A 9.08%, #907CFF 58.44%, #FC876D 103.84%)',
                  width: 6.05,
                  height: 12.73,
                  position: 'absolute',
                  left: 0,
                  top: '13%'
                }}
              >
              </View>

              <Text
                style={{
                  fontSize: 17,
                  fontWeight: "700",
                  color: "#0D256C",
                  paddingLeft: 12.29,
                  lineHeight: 17,
                  fontFamily: "Matteo-bold",
                  letterSpacing: "0.2em",
                }}
              >
                YESTERDAY
              </Text>
            </View>
            <Text
              style={[
                {
                  fontSize: helpers.isDesktop() ? 24 : 27,
                  lineHeight: helpers.isDesktop() ? 32 : 35,
                  fontFamily: FontFamily.abrilFatface,
                  color: darkMode
                    ? "white"
                    : helpers.isDesktop()
                      ? "#000000"
                      : "#051462",
                  fontWeight: "400",
                },
                { marginBottom: 15, paddingTop: 10, textAlign: "left" },
                darkMode && { color: "rgba(255, 255, 255, 0.89)" },
              ]}
            >
              {moment(storyData?.published_date).format("DD MMMM, YYYY")}
            </Text>

            {storyData &&
              storyData.posts &&
              storyData.posts.slice(0, 4).map((item, index) => {
                return (
                  <View
                    style={[
                      { backgroundColor: "#ffffff" },
                      { marginBottom: 30 },
                      darkMode && { backgroundColor: Colors.darkPurple },
                    ]}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        this.props.navigateWeb(`/yesterday/${storyData?.slug}?post_id=${index}`);
                      }}
                    >
                      <View
                        style={[
                          {
                            borderLeftWidth: 3,
                            borderColor: renderBorderColor(item?.category[0]),
                            padding: 10,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            {
                              fontSize: helpers.isDesktop() ? 18 : 18,
                              lineHeight: helpers.isDesktop() ? 19.8 : 26,
                              fontFamily: FontFamily.bold,
                              color: "#051462",
                            },
                            {
                              paddingBottom: 3,
                              textAlign: "left",
                              marginBottom: 10,
                            },
                            darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                          ]}
                        >
                          {item.title}
                        </Text>
                        <Text
                          style={[
                            {
                              fontSize: 16,
                              lineHeight: 23.48,
                              fontFamily: FontFamily.regular,
                              color: "#051462",
                              fontWeight: 400,
                            },
                            { paddingBottom: 3, textAlign: "left" },
                            darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                          ]}
                          numberOfLines={2}
                        >
                          {item.content}
                        </Text>
                        {/* <PostContent
                            data={truncate(item.content, 10, { byWords: true })}
                            darkMode={darkMode}
                            openLink={(link) => this.openSocialMedia(link)}
                          /> */}
                      </View>
                    </TouchableOpacity>
                  </View>
                );
              })}

            <View
              style={[
                Flex.row,
                helpers.isDesktop() ? Flex.justifyStart : Flex.justfiyCenter,
              ]}
            >
              <View style={{ width: helpers.isDesktop() ? 200 : "90%" }}>
                <ButtonGradient
                  title={
                    helpers.isDesktop()
                      ? "READ MORE"
                      : "READ MORE FROM YESTERDAY"
                  }
                  rootStyle={{
                    btnWrapper: [button.primaryGradient, { width: "100%" }],
                    btnText: [
                      button.primaryGradientText,
                      {
                        fontSize: 16,
                        fontWeight: "600",
                        fontFamily: helpers.isDesktop()
                          ? FontFamily.regular
                          : FontFamily.light,
                      },
                    ],
                  }}
                  onClick={() =>
                    this.props.navigateWeb(`/yesterday/${storyData?.slug}`)
                  }
                  darkMode={darkMode}
                />
              </View>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

export default AuthenticationWrapper(HomeYesterdayStory);
